
export const prefixes = {
  apk: ['apk-'],
  device: ['device-', 'telephone-'],
  policy: ['policy-', 'bypass-policy-', 'project-'],
  location: ['location'],
}
prefixes._all = [
  ...prefixes.apk,
  ...prefixes.device,
  ...prefixes.policy,
  ...prefixes.location,
]

export function toKeyPair (metaData) {
  return Object.keys(metaData)
        .filter(key => key.indexOf('_') !== 0)
        .map(key => ({ key, value: metaData[key] })) 
}

export function group(groupName, metaData) {
  const gp = prefixes[groupName]
  return toKeyPair(metaData)
    .filter(i => gp.filter(p => i.key.indexOf(p) === 0).length > 0)
}

export function others(metaData) {
  return toKeyPair(metaData)
    .filter(i => prefixes._all.filter(p => i.key.indexOf(p) === 0).length === 0)
}